import { useMutation, useQueryClient } from '@tanstack/react-query';
import { settingApi } from '../api/settingApi';

/**
 * POST /api/eraf/system-settings/{key}/reset
 * On success, invalidates the list and detail queries.
 */
export function useResetSetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (key: string) => settingApi.reset(key),
    onSuccess: (_data, key) => {
      void queryClient.invalidateQueries({ queryKey: ['system-settings', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['system-settings', 'detail', key] });
    },
  });
}
